import { render } from "./Parent.vue?vue&type=template&id=25db12d9&scoped=true"
import script from "./Parent.vue?vue&type=script&lang=js"
export * from "./Parent.vue?vue&type=script&lang=js"

import "./Parent.vue?vue&type=style&index=0&id=25db12d9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\pc\\Documents\\projets\\school_app_front_novation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25db12d9"]])

export default __exports__